<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9396_9409)">
      <path
        d="M14.4762 17.5238L27.338 3.14884C27.1255 3.08308 26.9 3.04761 26.6667 3.04761H2.28571C1.02857 3.04761 0 4.07618 0 5.33332V29.7143C0 29.9476 0.0354745 30.1731 0.101236 30.3856L14.4762 17.5238Z"
        fill="#0F9D58"
      />
      <path
        d="M14.4761 17.5239L1.61426 31.8989C1.82675 31.9646 2.05222 32.0001 2.28558 32.0001H26.6665C26.8999 32.0001 27.1254 31.9646 27.3379 31.8989L14.4761 17.5239Z"
        fill="#4285F4"
      />
      <path
        d="M14.4761 17.5239L28.851 30.3857C28.9168 30.1732 28.9523 29.9477 28.9523 29.7144V5.33343C28.9523 5.10007 28.9168 4.8746 28.851 4.66211L14.4761 17.5239Z"
        fill="#D2D2D2"
      />
      <path
        d="M28.9522 29.7143L15.238 16L12.5713 18.2857L26.2856 32H26.6665C27.9237 32 28.9522 30.9714 28.9522 29.7143Z"
        fill="#F1F1F1"
      />
      <path
        d="M26.6667 3.04761L0 29.7143C0 30.9714 1.02857 32 2.28571 32H2.66667L28.9524 5.71428V5.33332C28.9524 4.07618 27.9238 3.04761 26.6667 3.04761Z"
        fill="#FFDE48"
      />
      <path
        d="M26.6667 3.04761H2.28571C1.02857 3.04761 0 4.07618 0 5.33332V5.5238C0 4.26665 1.02857 3.23808 2.28571 3.23808H26.6667C27.9238 3.23808 28.9524 4.26665 28.9524 5.5238V5.33332C28.9524 4.07618 27.9238 3.04761 26.6667 3.04761Z"
        fill="white"
        fill-opacity="0.2"
      />
      <path
        d="M26.6667 31.8096H2.28571C1.02857 31.8096 0 30.7811 0 29.5239V29.7144C0 30.9715 1.02857 32.0001 2.28571 32.0001H26.6667C27.9238 32.0001 28.9524 30.9715 28.9524 29.7144V29.5239C28.9524 30.7811 27.9238 31.8096 26.6667 31.8096Z"
        fill="#263238"
        fill-opacity="0.1"
      />
      <path
        d="M6.47612 8.76182V10.3847H8.73135C8.5523 11.3485 7.70659 12.0494 6.47612 12.0494C5.1085 12.0494 3.99612 10.8913 3.99612 9.52753C3.99612 8.16373 5.1085 7.00563 6.47612 7.00563C7.09326 7.00563 7.64183 7.21897 8.07993 7.63039L9.27993 6.4304C8.55231 5.74849 7.60755 5.33325 6.47612 5.33325C4.15993 5.33325 2.28564 7.20754 2.28564 9.52373C2.28564 11.8399 4.15993 13.7142 6.47612 13.7142C8.89517 13.7142 10.499 12.0113 10.499 9.61897C10.499 9.32182 10.4723 9.03611 10.4228 8.76182L6.47612 8.76182Z"
        fill="#EEEEEE"
      />
      <mask
        id="mask0_9396_9409"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="32"
      >
        <path
          d="M24.3809 0C21.8895 0 19.6762 1.19619 18.2857 3.04762H2.28571C1.02857 3.04762 0 4.07619 0 5.33333V29.7143C0 30.9714 1.02857 32 2.28571 32H26.6667C27.9238 32 28.9524 30.9714 28.9524 29.7143V14.7924C30.5524 12.4533 32 10.3467 32 7.61905C32 3.40952 28.5905 0 24.3809 0Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_9396_9409)">
        <g
          opacity="0.25"
          filter="url(#filter0_f_9396_9409)"
        >
          <path
            d="M24.3808 0C20.1712 0 16.7617 3.40952 16.7617 7.61905C16.7617 13.36 23.1731 16.3505 23.9312 24.5448C23.9541 24.7733 24.1484 24.9524 24.3808 24.9524C24.6131 24.9524 24.8112 24.7733 24.8303 24.5448C25.5884 16.3505 31.9998 13.36 31.9998 7.61905C31.9998 3.40952 28.5903 0 24.3808 0Z"
            fill="#DB4437"
          />
        </g>
      </g>
      <path
        d="M24.3808 0C20.1712 0 16.7617 3.40952 16.7617 7.61905C16.7617 13.36 23.1731 16.3505 23.9312 24.5448C23.9541 24.7733 24.1484 24.9524 24.3808 24.9524C24.6131 24.9524 24.8112 24.7733 24.8303 24.5448C25.5884 16.3505 31.9998 13.36 31.9998 7.61905C31.9998 3.40952 28.5903 0 24.3808 0Z"
        fill="#DB4437"
      />
      <path
        d="M24.381 10.2857C25.8538 10.2857 27.0477 9.09182 27.0477 7.61906C27.0477 6.1463 25.8538 4.95239 24.381 4.95239C22.9083 4.95239 21.7144 6.1463 21.7144 7.61906C21.7144 9.09182 22.9083 10.2857 24.381 10.2857Z"
        fill="#7B231E"
      />
      <path
        d="M24.3808 0.190475C28.5522 0.190475 31.9389 3.54285 31.996 7.69905C31.996 7.67238 31.9998 7.64571 31.9998 7.61905C31.9998 3.40952 28.5903 0 24.3808 0C20.1712 0 16.7617 3.40952 16.7617 7.61905C16.7617 7.64571 16.7655 7.67238 16.7655 7.69905C16.8227 3.54286 20.2093 0.190475 24.3808 0.190475Z"
        fill="white"
        fill-opacity="0.2"
      />
      <path
        d="M24.8303 24.3543C24.8112 24.5828 24.6131 24.7619 24.3808 24.7619C24.1484 24.7619 23.9503 24.5828 23.9312 24.3543C23.1808 16.1981 16.8265 13.1962 16.7655 7.50854C16.7655 7.54664 16.7617 7.58093 16.7617 7.61902C16.7617 13.36 23.1731 16.3505 23.9312 24.5447C23.9541 24.7733 24.1484 24.9524 24.3808 24.9524C24.6131 24.9524 24.8112 24.7733 24.8303 24.5447C25.5884 16.3504 31.9998 13.36 31.9998 7.61902C31.9998 7.58093 31.996 7.54664 31.996 7.50854C31.935 13.1962 25.5846 16.2019 24.8303 24.3543Z"
        fill="#3E2723"
        fill-opacity="0.2"
      />
      <path
        d="M24.3809 0C21.8895 0 19.6762 1.19619 18.2857 3.04762H2.28571C1.02857 3.04762 0 4.07619 0 5.33333V29.7143C0 30.9714 1.02857 32 2.28571 32H26.6667C27.9238 32 28.9524 30.9714 28.9524 29.7143V14.7924C30.5524 12.4533 32 10.3467 32 7.61905C32 3.40952 28.5905 0 24.3809 0Z"
        fill="url(#paint0_radial_9396_9409)"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_9396_9409"
        x="-1183.24"
        y="-1200"
        width="2415.24"
        height="2424.95"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="600"
          result="effect1_foregroundBlur_9396_9409"
        />
      </filter>
      <radialGradient
        id="paint0_radial_9396_9409"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(0.794286 3.67847) scale(39.027)"
      >
        <stop
          stop-color="white"
          stop-opacity="0.1"
        />
        <stop
          offset="1"
          stop-color="white"
          stop-opacity="0"
        />
      </radialGradient>
      <clipPath id="clip0_9396_9409">
        <rect
          width="32"
          height="32"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
